<template>
  <div>
    <div class="col-12 col-lg-9">
      <template
        v-if="
          Object.keys(courseListByGroup[$route.params.groupId[5] - 1])
            .length !== 0
        "
      >
        <template
          v-for="(week, i) in courseListByGroup[$route.params.groupId[5] - 1]"
          :key="i"
        >
          <div class="week mb-2">第{{ chNo[i] }}週 Week {{ i }}</div>
          <div
            class="d-flex date-row mb-4"
            v-for="(date, k) in week"
            :key="date"
          >
            <div class="d-flex flex-column pe-5 column">
              <div class="date old-h3-bold">
                {{ formatDate(k) }}
              </div>
              <div class="weekday old-mini mt-1">
                星期{{ chNo[new Date(k).getDay()] }}
              </div>
            </div>
            <div class="courses d-flex flex-column flex-lg-row flex-fill">
              <div
                class="d-flex flex-column col column"
                v-for="c in date"
                :key="c.title"
              >
                <div class="topic title-en">{{ c.title }}</div>
                <div class="instructor old-small">{{ c.instructor }}</div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div v-else>研習營課程安排中，敬請期待！</div>
    </div>
    <div class="col-12 mt-5">
      <div class="mobile-h3 d-md-none text-center my-3">研習營師資</div>
      <section id="instructors">
        <div class="instructors-wrapper">
          <template
            v-for="(item, i) in instructorsByGroup[
              $route.params.groupId[5] - 1
            ]"
            :key="i"
          >
            <div class="d-inline-flex instructors-unit flex-column">
              <div class="text-start small-text w-100 d-none d-md-block">
                <template v-if="i + 1 < 10">0</template>{{ i + 1 }}
              </div>
              <Instructor :info="item" class="d-none d-sm-block"></Instructor>
              <InstructorM :info="item" class="d-sm-none"></InstructorM>
            </div>
          </template>
        </div>
        <div class="arrows text-end d-flex justify-content-end">
          <button class="flex-center scroll-btn scroll-left">
            <img :src="arrowLeft" alt="" />
          </button>
          <button class="flex-center scroll-btn scroll-right">
            <img :src="arrowRight" alt="" />
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';
import dayjs from 'dayjs';

import divider from '@/assets/img/divider.svg';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';

import Instructor from '@/components/camp-courses/Instructor.vue';
import InstructorM from '@/components/camp-courses/InstructorM.vue';

// api
import { getInstructorList } from '@/api/instructor';
import { getCampCourseList } from '@/api/camp-course';

export default {
  name: 'CampCourses',
  components: {
    // Carousel,
    // Slide,
    // Navigation,
    // Pagination,
    Instructor,
    InstructorM,
  },
  data() {
    return {
      arrowLeft,
      arrowRight,
      divider,
      chNo: ['日', '一', '二', '三', '四', '五', '六'],
      oScroll: null,
      instructors: [],
      courseList: [],
    };
  },
  computed: {
    courseListByGroup() {
      const tempGroup = [[], [], []];
      this.courseList.forEach((ele) => {
        tempGroup[ele.group - 1].push(ele);
      });
      const tempGroupWeek = [[], [], []];
      tempGroup.forEach((g, i) => {
        tempGroupWeek[i] = this.groupBy(g, 'week');
      });
      tempGroupWeek.forEach((w, i) => {
        Object.keys(w).forEach((ww) => {
          tempGroupWeek[i][ww] = this.groupBy(tempGroupWeek[i][ww], 'date');
        });
      });
      return tempGroupWeek;
    },
    instructorsByGroup() {
      const rst = [[], [], []];
      this.instructors.forEach((ele) => {
        rst[ele.group - 1].push(ele);
      });
      return rst;
    },
  },
  methods: {
    formatDate(dateString) {
      const date = dayjs(dateString);
      // Then specify how you want your dates to be formatted
      return date.format('MM/DD');
    },
    groupBy(xs, key) {
      return xs.reduce((rv, x) => {
        // eslint-disable-next-line no-param-reassign
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    mouseDownHandler(e) {
      const ele = document.querySelector('.os-viewport');
      this.pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
      ele.addEventListener('mousemove', this.mouseMoveHandler);
      ele.addEventListener('mouseup', this.mouseUpHandler);
      ele.addEventListener('mouseleave', this.mouseUpHandler);
    },
    mouseMoveHandler(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      const ele = document.querySelector('.os-viewport');
      ele.scroll({ x: this.pos.top - dy, y: this.pos.left - dx }, 500);
      // Scroll the element
      ele.scrollTop = this.pos.top - dy;
      ele.scrollLeft = this.pos.left - dx;
    },
    mouseUpHandler() {
      const ele = document.querySelector('.os-viewport');
      ele.removeEventListener('mousemove', this.mouseMoveHandler);
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');
    },
  },
  created() {
    let filter = { order: 'week asc, date asc, sort asc' };
    getCampCourseList({ filter }).then((response) => {
      this.courseList = response;
    });
    filter = { order: 'sort asc, updated_at desc' };
    getInstructorList({ filter }).then((response) => {
      this.instructors = response;
    });
  },
  mounted() {
    const cxt = this;
    setTimeout(() => {
      const settings = {
        className: 'os-theme-dark',
        sizeAutoCapable: true,
        paddingAbsolute: true,
        scrollbars: {
          clickScrolling: true,
          visibility: 'auto',
        },
        callbacks: {
          onScroll() {
            if (this.scroll().position.x === 0) {
              document.getElementById('instructors').classList.remove('left-fade');
            } else {
              document.getElementById('instructors').classList.add('left-fade');
            }
          },
          onInitialized() {
            document.querySelector('.os-viewport').addEventListener('mousedown', cxt.mouseDownHandler);
          },
        },
      };
      this.oScroll = OverlayScrollbars(document.querySelector('.instructors-wrapper'), settings);

      const page = document.querySelector('.page');
      const computedStyle = getComputedStyle(page);
      let sectionWidth = page.clientWidth; // width with padding
      sectionWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);

      document.querySelector('.scroll-left').addEventListener('click', () => this.oScroll.scroll({ x: (page.clientWidth < 575) ? `-= ${sectionWidth}` : '-= 360' }));
      document.querySelector('.scroll-right').addEventListener('click', () => this.oScroll.scroll({ x: (page.clientWidth < 575) ? `+= ${sectionWidth}` : '+= 360' }));
    }, 400);
  },
  watch: {
    '$route.params.groupId': function () {
      // 切換組別時回到開頭
      if (this.oScroll) this.oScroll.scroll({ x: 0 });
    },
  },
};
</script>
<style lang="stylus" scoped>
.week
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.04em;

.date-row
  border-top: 1px solid $monoc4;

  + .date-row
    margin-top: 28px;

  .column
    padding: 8px;

.courses > div:nth-child(n+2)
  border-left: 1px solid $monoc4;

#instructors
  position: relative;

.instructors-wrapper
  padding-bottom: 30px;
  white-space: nowrap;
  cursor: grab;

.instructors-unit
  width: 100%;

@media screen and (min-width: 576px)
  .instructors-unit
    width: 360px;
    height: 460px;
    overflow: hidden;

@media screen and (max-width: 575.5px)
  .instructors-wrapper
    padding-bottom: 12px;

  .instructors-unit
    height: 100%;

@media screen and (max-width: 991.5px)
  .courses > div:nth-child(n+2)
    border-left: 0;
    border-top: 1px solid $monoc4;

#instructors
  width: 100%;

@media screen and (min-width: 768px)
  #instructors
    &:after, &.left-fade:before
      content: '';
      position: absolute;
      z-index: 1;
      bottom: 30px;
      pointer-events: none;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);
      width: 50px;
      height: 100%;

    &:after
      right: -15px;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

    &.left-fade:before
      left: -15px;
      background-image: linear-gradient(to left, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

.instructor-block
  cursor: grab;
</style>
